export default {
  name: "list-page",
  data: function data() {
    return {
      dataList: []
    };
  }
};